import React from 'react'
import PropTypes from 'prop-types'

function Image({
  src,
  lowResSrc,
  className,
  alt,
  isLazy,
  ...otherProps
}) {
  return (
    <div
      className={[
        'mz-image',
        isLazy ? 'lazy' : '',
        className
      ].join(' ')}
    >
      <img
        src={isLazy ? lowResSrc : src}
        data-src={isLazy ? src : undefined}
        alt={alt}
        {...otherProps}
      />
    </div>
  )
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  lowResSrc: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  isLazy: PropTypes.bool,
}

Image.defaultProps = {
  lowResSrc: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
  className: '',
  isLazy: true,
}

export default Image